import cn from 'classnames';
import React from 'react';

import IqosLogoAnimated from '../../Icons/IqosLogoAnimated';
import styles from './Header.module.scss';

const Header = (props) => {
    const {className} = props;

    return (
        <header className={cn(styles.Header, className)}>
            <IqosLogoAnimated />
        </header>
    );
};

export default Header;
